export { renderImageSwatch_unstable as renderImageSwatch } from '@fluentui/react-swatch-picker';
